"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.isApiError = exports.axiosBaseQuery = void 0;
var axios_1 = __importStar(require("axios"));
var angular_1 = __importDefault(require("angular"));
var handleAuth0redirect_1 = require("../utils/handleAuth0redirect");
axios_1.default.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    var sentryService = window.sentryService;
    if (error.response) {
        // The request was made, but the server responded with an error status code
        var _a = error.response, status_1 = _a.status, data = _a.data, config = _a.config;
        if (status_1 !== 401 && status_1 !== 403 && status_1 !== -1) {
            sentryService.captureException(new Error("API Error - Status: ".concat(status_1, ", Method: ").concat(config.method, ", Url: ").concat(config.url, "  Data: ").concat(JSON.stringify(data))));
        }
        if (status_1 === 401) {
            (0, handleAuth0redirect_1.redirectToAuth0Form)();
            var html = document.querySelector('html');
            var $injector = angular_1.default.element(html).injector();
            var CurrentUser = $injector.get('CurrentUser');
            CurrentUser && CurrentUser.logOut('You need to login to access this page');
        }
    }
    else if (error.request) {
        // The request was made but no response was received
        sentryService.captureException(new Error('API Error - No response received'));
    }
    else {
        // Something happened in setting up the request that triggered an Error
        sentryService.captureException(new Error('API Error - Request setup failed'));
    }
    return Promise.reject(error);
});
var getHeaders = function () { return ({ withCredentials: true, crossDomain: true }); };
/**
 * Convert an AxiosError to an ApiError (our custom type)
 * @param error
 */
var handleError = function (error) {
    var _a, _b, _c, _d;
    if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 403) {
        window.location.href = '/forbidden';
    }
    return Promise.reject({
        message: error.message,
        name: error.name,
        data: (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data,
        status: (_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.status,
        config: (_d = error === null || error === void 0 ? void 0 : error.response) === null || _d === void 0 ? void 0 : _d.config,
    });
};
var axiosBaseQuery = function (_a) {
    var _b = _a === void 0 ? { baseUrl: '', withCredentials: false } : _a, baseUrl = _b.baseUrl, withCredentials = _b.withCredentials;
    return function (_a) {
        var url = _a.url, method = _a.method, data = _a.data;
        return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.request({ url: baseUrl + url, method: method, data: data, withCredentials: withCredentials })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, { data: response.data }];
                    case 2:
                        error_1 = _b.sent();
                        if ((0, axios_1.isAxiosError)(error_1)) {
                            return [2 /*return*/, handleError(error_1)];
                        }
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
};
exports.axiosBaseQuery = axiosBaseQuery;
function isApiError(object) {
    return Object.prototype.hasOwnProperty.call(object, 'status');
}
exports.isApiError = isApiError;
exports.Api = {
    get: function (path, config) {
        var fullUrl = "".concat(path.startsWith('/') ? BASE_URL : '').concat(path);
        return axios_1.default.get(fullUrl, __assign(__assign({}, config), getHeaders())).catch(handleError);
    },
    put: function (path, data) { return axios_1.default.put(BASE_URL + path, data, getHeaders()).catch(handleError); },
    post: function (path, data, config) {
        return axios_1.default.post(BASE_URL + path, data, __assign(__assign({}, config), getHeaders())).catch(handleError);
    },
    delete: function (path) { return axios_1.default.delete(BASE_URL + path, getHeaders()).catch(handleError); },
    patch: function (path, data) { return axios_1.default.patch(BASE_URL + path, data, getHeaders()).catch(handleError); },
};
var endpointList = {
    getSiteDetails: function (params) { return exports.Api.get("/sites/".concat(params.domain)); },
    putSiteDetails: function (params, payload) { return exports.Api.put("/sites/".concat(params.domain), payload); },
    getUserLocation: function () { return exports.Api.get('/location'); },
    postChangePassword: function (_, payload) { return exports.Api.post('/user/change_password', payload); },
    postUserContentDeletionJobs: function (params, payload) { return exports.Api.post("/sites/".concat(params.domain, "/user_content_deletion_jobs"), payload); },
    putEndpointUrl: function (params, payload) { return exports.Api.put("/sites/".concat(params.domain, "/endpoint-url"), payload); },
    getRetentions: function () { return exports.Api.get('/retentions'); },
    getSiteRetention: function (params) { return exports.Api.get("/sites/".concat(params.domain, "/retention")); },
    putSiteRetention: function (params, payload) { return exports.Api.put("/sites/".concat(params.domain, "/retention"), payload); },
    getSiteContentDeletionJobs: function (params) { return exports.Api.get("/sites/".concat(params.domain, "/site_content_deletion_jobs")); },
    deleteSiteContentDeletionJobs: function (params) { return exports.Api.delete("/sites/".concat(params.domain, "/site_content_deletion_jobs/").concat(params.jobId)); },
    postSiteContentDeletionJobs: function (params, payload) { return exports.Api.post("/sites/".concat(params.domain, "/site_content_deletion_jobs"), payload); },
    getRoles: function () { return exports.Api.get('/roles'); },
    postInvites: function (params, payload) { return exports.Api.post("/sites/".concat(params.domain, "/invites"), payload); },
    getMembers: function (params) { return exports.Api.get("/sites/".concat(params.domain, "/members")); },
    postUserRoles: function (params, payload) { return exports.Api.post("/sites/".concat(params.domain, "/user/roles"), payload); },
    getInvites: function (params) { return exports.Api.get("/sites/".concat(params.domain, "/invites")); },
    putInvitesRole: function (params, payload) { return exports.Api.put("/sites/".concat(params.domain, "/invites"), payload); },
    getModerationSettings: function (params) { return exports.Api.get("/sites/".concat(params.domain, "/settings/manual")); },
    putModerationSettings: function (params, payload) { return exports.Api.put("/sites/".concat(params.domain, "/settings/manual"), payload); },
    getOrchestrationSettings: function (params) { return exports.Api.get("/sites/".concat(params.domain, "/orchestration")); },
    putOrchestrationSettings: function (params, payload) { return exports.Api.put("/sites/".concat(params.domain, "/orchestration"), payload); },
    getSearchDocuments: function (params) {
        return exports.Api.get("/sites/".concat(params.domain, "/ads/queryDs"), {
            params: __assign({}, params),
        });
    },
    // Statistics
    // getStatsQueues is similar to getQueues but contains extra information (count: number;   oldest?: string;)
    getStatsQueues: function (params) { return exports.Api.get("/sites/".concat(params.domain, "/stats/queues")); },
    deleteQueue: function (params) { return exports.Api.delete("/sites/".concat(params.domain, "/queues/").concat(params.queueId)); },
    getStatsOverall: function (params) {
        return exports.Api.get("/sites/".concat(params.domain, "/stats/overall?from=").concat(params.from, "&to=").concat(params.to, "&tz=").concat(params.tz));
    },
    // TODO verify timeout is passed correctly in getDocumentsCount
    //  ajax.get(`/sites/${domain}/ads/count`,{params: {domain, query}, timeout}),
    getDocumentsCount: function (params) {
        return exports.Api.get("/sites/".concat(params.domain, "/ads/count?domain=").concat(params.domain, "&query=").concat(params.query, "&timeout=").concat(params.timeout));
    },
    postReportRequest: function (params, payload) { return exports.Api.post("/sites/".concat(params.domain, "/report/number-aggregate"), payload); },
    getReport: function (params) {
        return exports.Api.get("/sites/".concat(params.domain, "/report/").concat(params.fileName), { responseType: 'blob' });
    },
    // Items
    getAd: function (params) { return exports.Api.get("/ads/".concat(params.domain, "/").concat(params.id)); },
    getImage: function (params) { return exports.Api.get(params.imageRequestUrl, { responseType: 'arraybuffer' }); },
    patchFiltersDictionariesItems: function (params, payload) {
        return exports.Api.patch("/sites/".concat(params.domain, "/filters/dictionaries/").concat(params.listName, "/items"), payload);
    },
    postModerationNote: function (params, payload) { return exports.Api.post("/sites/".concat(params.domain, "/moderationNotes"), payload); },
    deleteModerationNote: function (params) { return exports.Api.delete("/sites/".concat(params.domain, "/moderationNotes/").concat(params.moderationNoteId)); },
    getDecisions: function (params) { return exports.Api.get("/sites/".concat(params.domain, "/decisions")); },
    putDecisionForOneJob: function (params, payload) {
        return exports.Api.put("/ads/".concat(params.domain, "/").concat(params.id, "/decision"), payload);
    },
    putDecisionForMultipleJobs: function (params, payload) {
        return exports.Api.put("/ads/".concat(params.domain, "/decisions"), payload);
    },
    getUserPreviousItemsCount: function (params, _, controller) {
        return exports.Api.get("/sites/".concat(params.domain, "/ads/count"), {
            params: {
                domain: params.domain,
                query: "document.user.id: \"".concat(params.userId, "\" AND metadata.result: ").concat(params.status),
            },
            signal: controller && controller.signal,
        });
    },
    getTrustedDomains: function (params) { return exports.Api.get("/sites/".concat(params.domain, "/trustedDomains")); },
    patchTrustedDomain: function (params, payload) { return exports.Api.patch("/sites/".concat(params.domain, "/trustedDomains"), payload); },
    deleteDictionary: function (params) { return exports.Api.delete("/sites/".concat(params.domain, "/filters/dictionaries/").concat(params.name)); },
    getDictionaries: function (params) { return exports.Api.get("/sites/".concat(params.domain, "/filters/dictionaries?kind=").concat(params.kind)); },
    // dictionaries and phashImages are using the same api /dictionaries so we need to distinguish them with kind
    postDictionary: function (params, payload) { return exports.Api.post("/sites/".concat(params.domain, "/filters/dictionaries"), payload); },
    getDictionary: function (params) { return exports.Api.get("/sites/".concat(params.domain, "/filters/dictionaries/").concat(params.name)); },
    patchDictionary: function (params, payload) { return exports.Api.patch("/sites/".concat(params.domain, "/filters/dictionaries/").concat(params.name), payload); },
    getRules: function (params) { return exports.Api.get("/sites/".concat(params.domain, "/filters")); },
    getRuleById: function (params) { return exports.Api.get("/sites/".concat(params.domain, "/filters/").concat(params.id)); },
    postRule: function (params, payload) { return exports.Api.post("/sites/".concat(params.domain, "/filters"), payload); },
    deleteRule: function (params) { return exports.Api.delete("/sites/".concat(params.domain, "/filters/").concat(params.id)); },
    updateRule: function (params, payload) { return exports.Api.patch("/sites/".concat(params.domain, "/filters/").concat(params.id), payload); },
    updateRuleStatus: function (params, payload) { return exports.Api.patch("/sites/".concat(params.domain, "/filters/").concat(params.id), payload); },
    searchRulesByQueue: function (params) { return exports.Api.get("/sites/".concat(params.domain, "/searchFiltersByQueueId?queueId=").concat(params.queueId)); },
    postQueue: function (params, payload) { return exports.Api.post("/sites/".concat(params.domain, "/queues"), payload); },
    putQueue: function (params, payload) { return exports.Api.put("/sites/".concat(params.domain, "/queues/").concat(params.queueId), payload); },
    getUser: function () { return exports.Api.get('/user'); },
    redirectToAuth0Form: function (_, payload, controller) {
        return exports.Api.post('/auth0/login', payload, { signal: controller === null || controller === void 0 ? void 0 : controller.signal });
    },
    createTeam: function (_, payload) { return exports.Api.post('/sites', payload); },
    getTeamCreationStatus: function (params) { return exports.Api.get("/sites/".concat(params.domain, "/creationStatus")); },
    logout: function () { return exports.Api.post('/auth0/logout'); },
    changePassword: function () { return exports.Api.post('/auth0/change-password'); },
    enableMFA: function (_, payload) { return exports.Api.post('/auth0/enroll-mfa', payload); },
    getDictionaryV2: function (params) { return exports.Api.get("/sites/".concat(params.domain, "/filters/v2/dictionaries/").concat(params.name)); },
    getProcessAds: function (params, payload) { return exports.Api.post("/sites/".concat(params.domain, "/ads/process"), payload); },
    getItem: function (params) { return exports.Api.get("/ads/".concat(params.domain, "/").concat(params.itemId)); },
    getDuplicateAdsCount: function (params, payload) { return exports.Api.post("/sites/".concat(params.domain, "/ads/duplicates/count"), payload); },
    getModerationNotes: function (params) { return exports.Api.get("/sites/".concat(params.domain, "/moderationNotes"), { params: params }); },
    postNewApiKey: function (params) { return exports.Api.post("/sites/".concat(params.domain, "/api-keys")); },
    searchDocumentsV2: function (params, payload) { return exports.Api.post("/sites/".concat(params.domain, "/ads/v2/search"), payload); },
    searchDocumentsCountV2: function (params, payload) { return exports.Api.post("/sites/".concat(params.domain, "/ads/v2/count"), payload); },
    testFilterRule: function (params, payload) { return exports.Api.post("/sites/".concat(params.domain, "/filters/test"), payload); },
    getLatestAd: function (params) { return exports.Api.get("/sites/".concat(params.domain, "/ads/latest")); },
    validateBlangRule: function (params, rule) { return exports.Api.post("/sites/".concat(params.domain, "/filters/rule/validate"), { rule: rule }); },
    getBlangVariables: function (params) { return exports.Api.get("/sites/".concat(params.domain, "/blangVariables")); },
};
exports.default = endpointList;
